module.exports = __webpack_public_path__ + "img/call.7b478f9d.png";